module.exports = __webpack_public_path__ + "img/2.aff0ef07.png";